// nav item with nav link
import * as userSession from "../../services/session";
import { navLink } from "./navLink";
import classNames from 'classnames';


export const navItem = (item, key, manageSubMenu, backToMainMenu) => {
  let put = false

  if (item.seller && userSession.testRole('ROLE_TCP')) put = true

  if (item.seller && userSession.testRole('ROLE_ADV')) put = true

  if (item.buyer && userSession.testRole('ROLE_USER')) put = true

  if (userSession.testRole('ROLE_ADMIN') || item.children) put = true

  const classes = {
    item: classNames(item.class),
    link: classNames('nav-link', item.variant ? `nav-link-${item.variant}` : ''),
    icon: classNames(item.icon)
  }

  const onclickItem = (item) => {
    if (manageSubMenu && item.children) {
      manageSubMenu(item)
    } else {
      if (backToMainMenu) backToMainMenu()
      document.body.classList.toggle("sidebar-mobile-show");
    }
  }

  if (put) {
    return navLink(item, key, classes, onclickItem)
  }
}



// WEBPACK FOOTER //
// ./src/components/Sidebar/navItem.js